module.exports = __webpack_public_path__ + "static/media/blood-15.ebad10b8.png";